import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Label,
  Form,
  FormGroup,
  Collapse,
  Modal,
  ModalBody,
} from "reactstrap";
import MaterialTable from "material-table";

import "../../assets/scss/components/MeterialTable/index.scss";
import "react-toastify/dist/ReactToastify.css";
import InputText from "../InputText";

import moment from "moment";

import CartTitle from "../CartTitle";
import CustomButton from "../CustomButton";
import Loader from "../Loader";
import get from "lodash/get";

import VinDetailPopup from "../VinModerationDetailPopup";

const _ = { get };

class VinList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toggleActive: true,
      toggleCollapse: false,
      page: 0,
      phone: "",
      email: "",
      count: 100,
      status: "PENDING",
      pageSize: 10,
      exportEmail: "",
      firstName: "",
      toggleDetail: false,
      rowData: null,
      toggleModal: false,
      selectedData: "",
      guid: "",
    };
  }

  componentDidMount() {
    let state = this.state;
    let data = {
      page: 0,
      status: state.status,
      phone: state.phone,
      email: state.email,
      count: state.count,
    };
    this.props.fetchTransferModerationListing(data);
  }

  handleOnChangePageSize = (count) => {
    let state = this.state;
    state.pageSize = count;
    this.setState({ ...state });
  };

  handleOnPageChange = (e, page) => {
    let totalPages =
      this.props.transferModerationListing.length / this.state.pageSize;
    let fetchNextData =
      e >= totalPages - 2 &&
      this.props.transferModerationListing.length !== 0 &&
      this.props.transferModerationListingStatus === false &&
      this.props.transferModerationListing.length <
        this.props.transferModerationCount;

    if (fetchNextData === true) {
      let obj = {
        page: this.state.page,
        count: this.state.count,
        status: this.state.status,
        email: this.state.email,
        phone: this.state.phone,
      };
      this.props.fetchTransferModerationListing(obj);
    }
  };

  handleFilterChange = (e, id) => {
    let state = this.state;
    if (id === "email") {
      state[e.target.name] = e.target.value;
      this.setState({ ...state });
    }
    if (id === "phone") {
      state[e.target.name] = e.target.value;
      this.setState({ ...state });
    }
  };

  handleToggle = (e) => {
    let state = this.state;
    state.toggleActive = !state.toggleActive;
    if (state.toggleCollapse === true) {
      state.toggleCollapse = !state.toggleCollapse;
      this.setState({ ...state });
    }
    this.setState({ ...state });
  };

  handleToggleDetail = (e, rowData) => {
    let state = this.state;
    state.toggleDetail = !state.toggleDetail;
    state.rowData = rowData;
    this.setState({ ...state });
  };

  handleChangeStatus = (e) => {
    let newState = { ...this.state };
    newState.status = e.target.value;
    this.setState({ ...newState });
  };

  handleToggleModel = (e) => {
    let newState = { ...this.state };
    newState.toggleModal = !newState.toggleModal;
    this.setState({ ...newState });
  };

  handleRowData = (rowData) => {
    console.log("Checking rowdata", rowData);
    let newState = { ...this.state };
    newState.selectedData = rowData;
    newState.toggleModal = !newState.toggleModal;
    this.setState({ ...newState });
  };

  handleStatusSubmit = (data) => {
    this.props.moderationTransfer(data);
  };

  handleSubmitFilter = (e) => {
    e.preventDefault();
    let state = this.state;
    let data = {
      page: 0,
      status: state.status,
      phone: state.phone,
      email: state.email,
      count: state.count,
    };

    if (
      state.status !== "PENDING" ||
      state.phone !== "" ||
      state.email !== "" ||
      state.count !== ""
    ) {
      this.props.fetchTransferModerationListing(data);
    }
  };

  handleClearFilter = () => {
    let state = this.state;
    state.page = 0;
    state.status = "PENDING";
    state.email = "";
    state.phone = "";
    state.count = "";
    state.firstName = "";
    this.setState({ ...state });
    let data = {
      page: 0,
      status: "PENDING",
      phone: "",
      email: "",
      count: "",
    };

    this.props.fetchTransferModerationListing(data);
  };

  render() {
    let { elements } = this.props;
    return (
      <React.Fragment>
        {this.props.transferModerationListingStatus !== false ? (
          <Loader />
        ) : null}
        <div className="userListing hideSearch">
          <Form onSubmit={this.handleSubmitFilter}>
            <Row>
              <Col sm={12}>
                <CartTitle
                  title={"VIN Moderation"}
                  Name={_.get(
                    elements,
                    "vinModerationListingElements.filterButtonElement",
                    "Filter"
                  )}
                  iconClass={"hideexcel"}
                  handleToggle={() => this.handleToggle()}
                  textTitle={_.get(
                    elements,
                    "vinModerationListingElements.totalCountElement",
                    "Total Count - "
                  )}
                  preRegisteredUserCount={this.props.transferModerationCount}
                />
              </Col>
              <Col sm={12}>
                <Collapse isOpen={this.state.toggleActive}>
                  <Card className="mb-3">
                    <CardBody>
                      <Row>
                        <Col lg={4}>
                          <InputText
                            labelName={_.get(
                              elements,
                              "vinModerationListingElements.emailLabel",
                              "Email"
                            )}
                            inputType={"email"}
                            inputName={"email"}
                            InputClass={"inputText mb-0"}
                            inputPlaceholder={_.get(
                              elements,
                              "vinModerationListingElements.emailPlaceholder",
                              "Email"
                            )}
                            customValue={this.state.email}
                            customOnChange={(e) =>
                              this.handleFilterChange(e, "email")
                            }
                          />
                        </Col>
                        <Col lg={4}>
                          <InputText
                            labelName={_.get(
                              elements,
                              "vinModerationListingElements.mobileLabel",
                              "Phone Number"
                            )}
                            inputType={"number"}
                            inputName={"phone"}
                            InputClass={"inputText mb-0"}
                            inputPlaceholder={_.get(
                              elements,
                              "vinModerationListingElements.mobilePlaceholder",
                              "Phone Number"
                            )}
                            customValue={this.state.phone}
                            customOnChange={(e) =>
                              this.handleFilterChange(e, "phone")
                            }
                          />
                        </Col>
                        <Col lg={4}>
                          <Label className="inputLabel">
                            {_.get(
                              elements,
                              "vinModerationListingElements.statusLabel",
                              "Status"
                            )}
                          </Label>
                          <FormGroup className="inputWrpper customInputBox">
                            <Input
                              type="select"
                              name="City"
                              value={this.state.status}
                              className="w-100 customeSelectBtn"
                              onChange={this.handleChangeStatus}
                            >
                              <option value={"PENDING"}>
                                {_.get(
                                  elements,
                                  "statusElement.pendingElement",
                                  "Pending"
                                )}
                              </option>
                              <option value={"APPROVED"}>
                                {_.get(
                                  elements,
                                  "statusElement.approvedElement",
                                  "Approved"
                                )}
                              </option>
                              <option value={"REJECTED"}>
                                {_.get(
                                  elements,
                                  "statusElement.rejectedElement",
                                  "Rejected"
                                )}
                              </option>
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>
                      <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                        <CustomButton
                          customType={"submit"}
                          name={_.get(
                            elements,
                            "vinModerationListingElements.searchButtonElement",
                            "Search"
                          )}
                          customClass={"btn-outline-dark bg-none btnthemeColor"}
                          customDisable={
                            this.state.status !== "PENDING" ||
                            this.state.phone !== "" ||
                            this.state.email !== "" ||
                            this.state.count !== "" ||
                            this.state.firstName !== ""
                              ? false
                              : true
                          }
                        />
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "vinModerationListingElements.clearFilterButtonElement",
                            "Clear Filter"
                          )}
                          customClass={
                            "btn-outline-dark bg-none ml-2 btnthemeColor"
                          }
                          customClick={() => this.handleClearFilter()}
                          customDisable={
                            this.state.status !== "PENDING" ||
                            this.state.phone !== "" ||
                            this.state.email !== "" ||
                            this.state.count !== "" ||
                            this.state.firstName !== ""
                              ? false
                              : true
                          }
                        />
                      </div>
                    </CardBody>
                  </Card>
                </Collapse>
                <Collapse isOpen={this.state.toggleCollapse}>
                  <Card className="mb-3">
                    <CardBody>
                      <Row className="justify-content-start">
                        <Col lg={4}>
                          <InputText
                            labelName={_.get(
                              elements,
                              "vinModerationListingElements.exportToExcelEmailLabel",
                              "Email"
                            )}
                            inputType={"email"}
                            inputName={"exportEmail"}
                            InputClass={"inputText mb-0"}
                            inputPlaceholder={_.get(
                              elements,
                              "vinModerationListingElements.exportToExcelEmailPlaceholder",
                              "Email"
                            )}
                            customValue={this.state.exportEmail}
                            customOnChange={(e) =>
                              this.handleFilterChange(e, "email")
                            }
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Collapse>
              </Col>
            </Row>
          </Form>

          <Row>
            <Col sm="12">
              <div className="custom-m-table">
                <MaterialTable
                  title=""
                  columns={[
                    {
                      title: _.get(
                        elements,
                        "vinModerationListingElements.emailLabel",
                        "Email"
                      ),
                      field: "Email",
                      render: (rowData) =>
                        `${rowData.userID &&
                          rowData.userID.contactDetails &&
                          rowData.userID.contactDetails.email}`,
                    },
                    {
                      title: _.get(
                        elements,
                        "vinModerationListingElements.modelNameLabel",
                        "Model Name"
                      ),
                      field: "vehicleModelName",
                      render: (rowData) => `${rowData.vehicleModelName}`,
                    },
                    {
                      title: _.get(
                        elements,
                        "vinModerationListingElements.mobileLabel",
                        "Phone Number"
                      ),
                      field: "phone",
                      render: (rowData) =>
                        `${rowData.userID &&
                          rowData.userID.contactDetails &&
                          rowData.userID.contactDetails.mobile &&
                          rowData.userID.contactDetails.mobile.primary.number}`,
                    },
                    {
                      title: _.get(
                        elements,
                        "vinModerationListingElements.vinLabel",
                        "VIN"
                      ),
                      field: "vin",
                      render: (rowData) => `${rowData.vin}`,
                    },
                    {
                      title: _.get(
                        elements,
                        "vinModerationListingElements.createdAtLabel",
                        "Created At (GMT)"
                      ),
                      field: "createdAt",
                      render: (rowData) =>
                        `${moment(rowData.createdAt)
                          .utc()
                          .format("DD-MM-YY, HH:mm:ss")}`,
                    },
                    {
                      title: _.get(
                        elements,
                        "vinModerationListingElements.updatedAtLabel",
                        "Updated At (GMT)"
                      ),
                      field: "updatedAt",
                      render: (rowData) =>
                        `${moment(rowData.updatedAt)
                          .utc()
                          .format("DD-MM-YY, HH:mm:ss")}`,
                    },
                  ]}
                  data={this.props.transferModerationListing}
                  options={{
                    actionsColumnIndex: -1,
                    search: false,
                    paging: true,
                    sorting: false,
                    pageSize: this.state.pageSize,
                    paginationType: "stepped",
                    initialPage: 1,
                    showFirstLastPageButtons: false,
                  }}
                  actions={[
                    {
                      icon: "assignment_ind",
                      tooltip: _.get(
                        elements,
                        "vinModerationListingElements.detailPageTooltipElement",
                        "Detail Page"
                      ),
                      onClick: (event, rowData) => this.handleRowData(rowData),
                    },
                  ]}
                  onChangeRowsPerPage={(e) => this.handleOnChangePageSize(e)}
                  onChangePage={(e, page) => this.handleOnPageChange(e, page)}
                  localization={{
                    body: {
                      emptyDataSourceMessage: (
                        <h6>
                          {_.get(
                            elements,
                            "vinModerationListingElements.noRecordsFoundElement",
                            "No records to display"
                          )}
                        </h6>
                      ),
                    },
                    pagination: {
                      labelRowsSelect: _.get(
                        elements,
                        "customMaterialTableElement.labelRowsSelect",
                        "rows"
                      ),
                      previousTooltip: _.get(
                        elements,
                        "customMaterialTableElement.previousTooltip",
                        "previous"
                      ),
                      nextTooltip: _.get(
                        elements,
                        "customMaterialTableElement.nextTooltip",
                        "next"
                      ),
                    },
                    header: {
                      actions: _.get(
                        elements,
                        "vinModerationListingElements.actionsElement",
                        "Actions"
                      ),
                    },
                  }}
                />
              </div>
            </Col>
          </Row>
          <Modal
            isOpen={this.state.toggleModal}
            toggle={this.handleToggleModel}
            backdrop={true}
            centered={true}
            size="xl"
            className="modal_main"
          >
            <ModalBody>
              <VinDetailPopup
                handleClearPreviousReducer={
                  this.props.handleClearPreviousReducer
                }
                query={this.props.query}
                elements={this.props.elements}
                handleUpdateVin={this.props.handleUpdateVin}
                handleToggleModel={this.handleToggleModel}
                rowData={this.state.selectedData}
                transferModeration={this.transferModeration}
                handleStatusSubmit={this.handleStatusSubmit}
                count={this.state.count}
                phone={this.state.phone}
                email={this.state.email}
                page={this.state.page}
                currentStatus={this.state.status}
                fetchTransferModerationDetailListing={
                  this.props.fetchTransferModerationDetailListing
                }
                transferModerationDetailListing={
                  this.props.transferModerationDetailListing
                }
              />
            </ModalBody>
          </Modal>
        </div>
      </React.Fragment>
    );
  }
}

export default VinList;
